export enum SignalRActionTypes {
    AddCustomer = "Created",
    UpdateCustomer = "Modified",
    DeleteCustomer = "Deleted",
}

export {};